import React, { useState, useEffect, ReactNode } from "react"

type ChunkLoadErrorBoundaryProps = {
  children: ReactNode
}

const ChunkLoadErrorBoundary: React.FC<ChunkLoadErrorBoundaryProps> = ({ children }) => {
  const [hasError, setHasError] = useState<boolean>(false)

  useEffect(() => {
    const handleError = (error: Error) => {
      if (error.name === "ChunkLoadError") {
        window.location.reload()
        setHasError(true)
      }
    }

    // Simulate getDerivedStateFromError using an error boundary effect
    try {
      if (hasError) {
        return
      }
    } catch (error) {
      handleError(error as Error)
    }
  }, [hasError])

  if (hasError) {
    return null
  }

  return <>{children}</>
}

export default ChunkLoadErrorBoundary
